import script from "./SchoolCodeInputForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolCodeInputForm.vue?vue&type=script&setup=true&lang=js"

export default script